<template>
  <div class="flex w-full flex-row flex-wrap items-center justify-center gap-2">
    <PButton
      v-for="(option, index) in fixed_options"
      :key="option.index"
      :variant="selected_index === index ? '' : 'outlined'"
      @click="!disabled && selectAnswer(index)"
      class="w-full"
    >
      <div>
        {{ option }}
      </div>
    </PButton>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  disabled: { type: Boolean, default: false },
  fixed_options: { type: Array, required: true },
});

const selected_index = ref(null);

const emits = defineEmits(['scoreSelected']);
const selectAnswer = (index) => {
  selected_index.value = index;
  emits('scoreSelected', index);
};
</script>
